import { theme } from '@blackhyve/common/src/AppTheme';
import AddIcon from '@mui/icons-material/Add';
import { Divider, List, ListItem, ListItemIcon, ListItemText, ThemeProvider } from '@mui/material';
import SearchBox from 'components/search/SearchBox';
import AddRecipeDialog from 'features/recipes/components/RecipeCreateDialog';
import { fetchRecipes, selectAllRecipes } from 'features/recipes/store/recipesSlice';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RecipeNavList } from '../../../features/recipes/components/RecipeNavList';
import { NavScrollBar } from '../NavScrollBar';
import { DrawerFilterMenu, DrawerFilterMenuItem } from '../menus/DrawerFilterMenu';

export const RecipeDrawer = () => {
  const dispatch = useDispatch();

  const recipes = useSelector((state) => selectAllRecipes(state));

  const [loading, setLoading] = useState(true);
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const [filterMenuAnchorEl, setFilterMenuAnchorEl] = useState(undefined);
  const [filters, setFilters] = useState({});

  const getFiltered = () => {
    let filterInProgress = recipes;
    //Filter
    Object.entries(filters).forEach(([key, value]) => {
      // Switch for expandability if key does not match objects field
      switch (key) {
        default:
          filterInProgress = filterInProgress.filter((recipe) => recipe[key] === value);
      }
    });
    // Search
    filterInProgress = filterInProgress.filter((recipe) => {
      return recipe.name.toLowerCase().includes(searchQuery.toLowerCase());
    });
    return filterInProgress.map((recipe) => recipe.id);
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  /**
   *
   * @param {*} input
   * @param {string} input.filterName - Name of field to match
   * @param {String|Number|Boolean} input.value - Value to match field to
   */
  const handleFilter = ({ filterName, value }) => {
    if (Object.hasOwn(filters, filterName) && filters[filterName] === value) {
      const filtersClone = { ...filters };
      delete filtersClone[filterName];
      setFilters(filtersClone);
    } else {
      setFilters({ ...filters, [filterName]: value });
    }
  };

  useEffect(() => {
    dispatch(fetchRecipes()).then(() => setLoading(false));
  }, [dispatch]);

  return (
    <>
      <List>
        <ListItem button onClick={() => setIsCreateDialogOpen(true)}>
          <ListItemIcon>
            <AddIcon />
          </ListItemIcon>
          <ListItemText primary={'New Recipe'} />
        </ListItem>
        {isCreateDialogOpen && (
          <ThemeProvider theme={theme}>
            <AddRecipeDialog
              handleClose={() => setIsCreateDialogOpen(false)}
              open={isCreateDialogOpen}
            />
          </ThemeProvider>
        )}

        <DrawerFilterMenu
          anchorEl={filterMenuAnchorEl}
          handleClose={() => setFilterMenuAnchorEl(undefined)}
        >
          <DrawerFilterMenuItem
            checked={filters['type'] === 'master'}
            primaryText={'Master'}
            onClick={() => handleFilter({ filterName: 'type', value: 'master' })}
          />
          <DrawerFilterMenuItem
            checked={filters['type'] === 'phase'}
            primaryText={'Phase'}
            onClick={() => handleFilter({ filterName: 'type', value: 'phase' })}
          />
          <DrawerFilterMenuItem
            checked={filters['type'] === 'lookahead'}
            primaryText={'Lookahead'}
            onClick={() => handleFilter({ filterName: 'type', value: 'lookahead' })}
          />
          <DrawerFilterMenuItem
            checked={filters['type'] === 'wwp'}
            primaryText={'Weekly Work Plan'}
            onClick={() => handleFilter({ filterName: 'type', value: 'wwp' })}
          />
        </DrawerFilterMenu>
        <ListItem>
          <SearchBox borderRadius={1} value={searchQuery} onChange={handleSearch} />
        </ListItem>
      </List>
      <Divider />
      <NavScrollBar>
        <RecipeNavList loading={loading} recipeIds={getFiltered()} />
      </NavScrollBar>
    </>
  );
};
